import { createUseStyles } from 'react-jss';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';

const useStyles = createUseStyles({
    root: {
        display: 'grid',
        gridAutoFlow: 'column',
        gap: Spacings.s8,
        width: '100%',
    },
    menuContainer: {
        maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight
            || count && `calc((${count} * ${sizes?.Default?.value?.height}px) + (${Spacings.s8} * ${count}) + 
    (${sizes?.Default?.value?.paddingHorizontal}))`),
        [BreakPointsMedia.XXL]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.XXL?.value?.height)
                && `calc((${count} * ${sizes?.XXL?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
        [BreakPointsMedia.XL]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.XL?.value?.height)
                && `calc((${count} * ${sizes?.XL?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
        [BreakPointsMedia.LG]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.LG?.value?.height)
                && `calc((${count} * ${sizes?.LG?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
        [BreakPointsMedia.MD]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.MD?.value?.height)
                && `calc((${count} * ${sizes?.MD?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
        [BreakPointsMedia.SM]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.SM?.value?.height)
                && `calc((${count} * ${sizes?.SM?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
        [BreakPointsMedia.XS]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.XS?.value?.height)
                && `calc((${count} * ${sizes?.XS?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
        [BreakPointsMedia.XXS]: {
            maxHeight: ({ scrollHeight, count, sizes }) => (scrollHeight || count && (sizes?.XXS?.value?.height)
                && `calc((${count} * ${sizes?.XXS?.value?.height}px) + (${Spacings.s8} * ${count}) + 
      (${sizes?.Default?.value?.paddingHorizontal}))`),
        },
    },
    menu: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: Spacings.s8,
    },
    mobileMenu: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        padding: [Spacings.s4, Spacings.s8],
        gap: Spacings.s8,
    },
    inVisibleContent: {
        visibility: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
    },
    badges: {
        display: 'inline-flex',
        alignItems: 'center',
        marginInlineStart: 'auto',
        gap: Spacings.s8,
        paddingInlineStart: Spacings.s4,
    },
    badge: {
        boxShadow: 'none',
    },
}, {
    name: 'select',
});

export { useStyles };
